import axios from 'axios';
import { BrandGroupConfig } from '../types/apiConfig';
import { store } from '../redux/store';

class BrandGroupService {
  private getApiConfig = () => store.getState().apiConfig;

  public async getBrandGroups(): Promise<BrandGroupConfig[]> {
    const result = await axios.get<BrandGroupConfig[]>(
      `${this.getApiConfig().apiRoot}/brand-groups`
    );
    return result.data;
  }
}

export const brandGroupService = new BrandGroupService();
